import { render, staticRenderFns } from "./DeptKolSelect.vue?vue&type=template&id=28bfe812&scoped=true"
import script from "./DeptKolSelect.vue?vue&type=script&lang=js"
export * from "./DeptKolSelect.vue?vue&type=script&lang=js"
import style0 from "./DeptKolSelect.vue?vue&type=style&index=0&id=28bfe812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bfe812",
  null
  
)

export default component.exports